import React from 'react';
import { Modal, Button, ListGroup } from 'react-bootstrap';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { IoIosPerson } from 'react-icons/io';
import './PartnerSelectModal.scss';

function PartnerSelectModal(props) {
    const { t } = useTranslation();

    const handleCallback = (partner) => {
        props.callback(props.event, partner)
    };

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {t('events.select_organization')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ListGroup>
                        {props.event.partners.map((partner) => (
                            <ListGroup.Item className="partnerSelectItem" key={partner.partnerID}>
                                <div>
                                    <Button size="sm" style={{float:'right'}} onClick={() => handleCallback(partner)}>{t('general.select')}</Button>
                                    <h4><IoIosPerson style={{color: "#0093BF", marginTop: -6}} /> {partner.name}</h4>
                                </div>
                                <p>{moment(partner.timeCreated).format('DD.MM.YYYY - HH:ss')}</p>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" variant="default" onClick={() => props.onHide()}>{t('general.close')}</Button>
                </Modal.Footer>
            </div>
        </Modal>
    );
}

export default PartnerSelectModal;